export const api = {
    videoTask: {
        queryAlarmDetail: '/bas/alarmSafeEvent/queryResult.json', //查询告警详情
        addJobDetail: '/vas/videoPatrol/addJobDetail.json', // 新增任务明细
        updateJobDetail: '/vas/videoPatrol/updateJobDetail.json', // 打卡接口
        updateDetail: '/vas/videoPatrol/updateDetail.json', // 更新任务明细
        queryJobs: '/vas/videoPatrol/queryJobs.json', // 任务列表
        JobDetail: '/vas/videoPatrol/queryJobDetail.json', //任务详情
        JobReport: '/vas/videoPatrol/addJobReport.json', //提交报告
        updateJob: '/vas/videoPatrol/updateJob.json', //手动启动更新
        startJob: '/vas/videoPatrol/restartJob.json', //重启任务
        preJobInfo: '/vas/videoPatrol/preJobReport.json', //任务数据回填
        upFile: '/common/file/batchFileload.json', //图片上传
        operateAlarm: '/bas/safeEvent/operateAlarmApi.json', //上报告警
        historyJob: '/vas/videoPatrol/queryHisJobs.json', //巡逻历史任务
        historyJobInfo: '/vas/videoPatrol/queryReport.json', //巡逻历史任务
        historyAlarm: '/bas/alarmSafeEvent/queryResult.json', //巡逻历史告警
        historyJobExport: '/vas/videoPatrol/exportPatrolHistory.json', //巡逻历史导出
        planStatus: 'vas/videoPatrol/updatePlanStatus.json', //计划状态
        planTaskStatus: 'vas/videoPatrol/queryPatrolTaskStatus.json', //查询计划是否执行
        addPlan: 'vas/videoPatrol/addPatrolPlan.json', //添加计划任务
        querySecurityWorkGroup: '/cms/workgroup/querySecurityWorkGroup.json', //查询保卫工作组树
        queryWorkerList: '/cms/workgroup/querySecurityWorkGroupTree.json', //查询工作组
        getSecurityInfoList: '/cms/workgroup/querySecurityInfo.json', //查询保卫工作组及子节点保卫信息
        updatePlan: 'vas/videoPatrol/updatePatrolPlan.json', //编辑计划任务
        detailPlan: 'vas/videoPatrol/queryPatrolPlanDetail.json', //详情计划任务
        deletePlan: 'vas/videoPatrol/deletePatrolPlan.json', //删除计划任务
        listPlan: 'vas/videoPatrol/queryPatrolPlans.json', //计划任务列表
        areaList: '/cms/workGroup/queryWorkGroupByAreaOrDevice.json', //创建计划任务区域列表
        updateVideoPatrolReport: '/vas/videoPatrol/updateVideoPatrolReport.json ', //补录巡逻历史报告
        queryDeviceList: '/bms/device/queryDeviceListByType.json ', //根据区域查询设备
        querySecurityWorkGroupApi: '/cms/workgroup/querySecurityWorkGroupApi.json', //查询隶属中队
        queryPatrolPlanNameList: '/vas/videoPatrol/queryPatrolPlanNameList.json', //巡逻计划名称列表
        // addPatrolPlanTemplate: '/vas/videoPatrol/addPatrolPlanTemplate.json', //新增模板
        // updatePatrolPlanTemplate: '/vas/videoPatrol/updatePatrolPlanTemplate.json', //修改
        // deletePatrolPlanTemplate: '/vas/videoPatrol/deletePatrolPlanTemplate.json', //删除
        queryHisJobs: '/vas/videoPatrol/queryHisJobs.json', //巡逻模板列表
        updatePatrolPlanTemplateStatus: '/vas/videoPatrol/updatePatrolPlanTemplateStatus.json'
    },
    // 查询实时视频播放地址
    queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
}